module.exports = __webpack_public_path__ + "img/loginbg.021d9e8c.png";